var map = {
	"./de/data.json": [
		28887,
		[
			8887
		]
	],
	"./en/data.json": [
		12719,
		[]
	],
	"./es/data.json": [
		52750,
		[
			2750
		]
	],
	"./fa/data.json": [
		65561,
		[
			5561
		]
	],
	"./fr/data.json": [
		93494,
		[
			3494
		]
	],
	"./ja/data.json": [
		16261,
		[
			6261
		]
	],
	"./pl/data.json": [
		55454,
		[
			5454
		]
	],
	"./pt/data.json": [
		83158,
		[
			3158
		]
	],
	"./tr/data.json": [
		79036,
		[
			9036
		]
	],
	"./uk/data.json": [
		46358,
		[
			6358
		]
	],
	"./vi/data.json": [
		5793,
		[
			5793
		]
	],
	"./zh/data.json": [
		64904,
		[
			4904
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__.t(id, 3 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 78663;
module.exports = webpackAsyncContext;